import { dayLabel, dayTime } from "./initialAssessment";

/**
 * "Pregătirea grupei", the trainer's card before the participants are
 * invited (15.10.2026). The words were validated in
 * docs/texte-invitatii-portal-pr2-2026-10-15.md; the server counts.
 */

export const INTRO =
  "Deocamdată doar tu vezi grupa. Pregătește temele și materialele, apoi anunță echipa FPED: echipa trimite "
  + "invitațiile cursanților. Ce publici acum le apare după invitație, fără câte un email pentru fiecare.";

export const NOTE_LABEL = "Ceva ce trebuie să știe echipa? (opțional)";
export const NOTE_EXAMPLE = "Materialele pentru sesiunea 3 le urc după prima sesiune.";
export const BUTTON = "Anunță echipa că grupa e pregătită";

const num = (h) => String(Math.round(Number(h || 0) * 100) / 100).replace(".", ",");

/** The rows of the list, each ticked by itself; the first session only informs. */
export function checklistRows(prep) {
  if (!prep) return [];
  const rows = [
    { key: "assignments", label: `Teme publicate: ${prep.assignments || 0}`, done: (prep.assignments || 0) > 0 },
    { key: "materials", label: `Materiale publicate: ${prep.materials || 0}`, done: (prep.materials || 0) > 0 },
  ];
  if (prep.hours) {
    rows.push({ key: "hours", label: `Ore asincrone acoperite: ${num(prep.hours.covered)} din ${num(prep.hours.required)}`,
      done: prep.hours.covered >= prep.hours.required });
  }
  const first = prep.first_session;
  if (first?.date) {
    const day = dayLabel(`${first.date}T12:00:00+03:00`);
    rows.push({ key: "first", label: `Prima sesiune: ${day}${first.start_time ? `, la ${first.start_time}` : ""}`,
      info: true });
  }
  return rows;
}

/** What the confirmation names, or "" when nothing is missing. */
export function missingLine(prep) {
  const gaps = [];
  if (!(prep?.assignments > 0)) gaps.push("nicio temă publicată");
  if (prep?.hours && prep.hours.covered < prep.hours.required) {
    gaps.push(`acoperite cele ${num(prep.hours.required)} ore asincrone`);
  }
  if (!gaps.length) return "";
  return `Încă nu ai ${gaps.join(" și nici ")}. Anunți totuși echipa? Poți adăuga teme și după invitație.`;
}

export const readyLine = (at) =>
  `Ai anunțat echipa pe ${dayTime(at)}. Echipa trimite invitațiile cursanților; până atunci poți continua să pregătești grupa.`;
